@import 'styles/variables';

.icon {
  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  margin-right: 10px;

  &.gray {
    path:last-child {
      fill: $grey-40;
    }
  }
}
